import { render, staticRenderFns } from "./OsListPlacas.vue?vue&type=template&id=6d7370bc&"
import script from "./OsListPlacas.vue?vue&type=script&lang=js&"
export * from "./OsListPlacas.vue?vue&type=script&lang=js&"
import style0 from "./OsListPlacas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports